import React, { useEffect } from 'react'
import { OnboardingPage } from './OnboardingWizard.styled'
import { useAccountStatus } from 'Features/MainWrapper/api/getAccountStatus'
import { useNavigate } from 'react-router-dom'
import { Onboarding } from './components/Onboarding'

export const OnboardingWizard = () => {
  const navigate = useNavigate()
  const { refetch: checkAccountStatus, data: accountIsActive } = useAccountStatus()

  const finishOnboarding = async () => {
    if (!accountIsActive) await checkAccountStatus()
    navigate('/')
  }

  useEffect(() => {
    if (accountIsActive) {
      void finishOnboarding()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [accountIsActive])

  return (
    <OnboardingPage>
      <Onboarding />
    </OnboardingPage>
  )
}
